import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import EditarSuperInstituto from "./editar-super-instituto";
import { fetchSuperInstitutos } from "../../../../shared/fetchers/classics/institutos/verSuperInstitutos";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Col, Container, Row } from "react-bootstrap";

const Index = () => {
  const [superInstituto, setSuperInstituto] = useState(null);

  const { data: superInstitutos, isLoading } = useQuery(
    ["superInstitutos"],
    fetchSuperInstitutos
  );

  if (isLoading) return <Skeleton variant="rect" width="100%" height={500} />;

  return (
    <>
    <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar Super Instituto</div>
      </div>
    <div>
    <Container fluid>
      <Row>
        <Col xs={12} className="content-white-box px-4 py-4">
      <Autocomplete
        options={superInstitutos}
        getOptionLabel={(option) => option.nombre}
        value={superInstituto}
        onChange={(_, value) => setSuperInstituto(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Selecciona un super instituto"
            variant="outlined"
          />
        )}
      />
      </Col>
      {superInstituto && (
        <EditarSuperInstituto
          superInstituto={superInstituto}
          clearEdit={() => setSuperInstituto(null)}
        />
      )}
      </Row>
    </Container>
    </div>
    </>
  );
};

export default Index; 